__turbopack_context__.v({
  "divider": "RestaurantFilters-module-sass-module__k3K0tq__divider",
  "skeleton": "RestaurantFilters-module-sass-module__k3K0tq__skeleton",
  "wrapper": "RestaurantFilters-module-sass-module__k3K0tq__wrapper",
});
